import { Box, Text } from 'ink';
import Link from 'ink-link';
import fixMacUrl from '../utilities/fixMacUrl';

const preLabelMaxWidth = 'More info: '.length;

export default function PlatformProgress({
  activityName,
  activityType,
  downloadUrl,
  percent,
  platform,
  shouldShowReadyPrefix,
}: {
  activityName: string;
  activityType: string;
  downloadUrl?: string;
  percent: number;
  platform: string;
  shouldShowReadyPrefix?: boolean;
}) {
  let progressIndicator;
  if (activityType === 'done') {
    if (platform === 'mac' && downloadUrl) {
      // Otherwise the download link may link to a Intel file when on Apple Silicon
      downloadUrl = fixMacUrl(downloadUrl);
    }
    progressIndicator = (
      <Box flexDirection="column" marginBottom={1}>
        <Text>
          {getProgressPercentageLabel(100)}
          {shouldShowReadyPrefix ? 'Ready!' : ''}
        </Text>
        <Link fallback={false} url={downloadUrl}>
          {downloadUrl}
        </Link>
      </Box>
    );
  } else {
    let activityNameToDisplay = activityName.replace(
      /(?:\r\n|\r|\n)\s*/g,
      '↵ ',
    );
    if (activityNameToDisplay.length > 64) {
      activityNameToDisplay = `${activityNameToDisplay.substr(0, 61)}...`;
    }

    progressIndicator = (
      <Box flexDirection="column" marginBottom={1}>
        <Text>
          {['preparation', 'queue'].includes(activityType)
            ? undefined
            : getProgressPercentageLabel(percent, activityType)}
          {activityNameToDisplay}
          {activityType === 'error' ? '' : <Text>...</Text>}
        </Text>
      </Box>
    );
  }
  return (
    <Box>
      <Box width={preLabelMaxWidth}>
        <Text>{platform[0].toUpperCase() + platform.substr(1)}: </Text>
      </Box>
      {progressIndicator}
    </Box>
  );
}

function getProgressPercentageLabel(percentage: number, activityType?: string) {
  let backgroundColor = 'white';
  let color = 'black';

  if (activityType === 'error') {
    backgroundColor = 'red';
  } else if (percentage === 100) {
    backgroundColor = 'green';
    color = 'black';
  }

  return (
    <>
      <Text backgroundColor={backgroundColor} color={color}>
        {' '}
        {Math.round(percentage).toString().padStart(2, '0')}%{' '}
      </Text>
      <Text> </Text>
    </>
  );
}
